/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as StudentActions from '../../actions/Student'
import * as CommonActions from '../../actions/Common'


import { EdwTable, EDWDropDown, EdwLoaderWithContainer } from 'edw-widgets';
import { getItem, setItem } from '../../common/utils/StorageManager';

const rowHeights = [40, 80, 120, 160, 200, 240, 280];


class Students extends Component {
    constructor(props) {
        super(props)
        this.state = {
            groupOrYear: '',
            subjectId: '',
            courseId: '',
            studentId: '',
            studentYear: '',
            students: [],
            isFiltered: false,
            isDataLoaded: false

        }

    }


    componentDidMount() {
        this.initStudentList();
    }

    initStudentList = () => {
        this.props.actions.fetchAllStudents(this.props.accessToken);
        this.props.actions.fetchSubjects(this.props.accessToken);
        this.props.actions.fetchCourse(this.props.accessToken);
        this.props.actions.fetchGroupListForDropDown(this.props.accessToken);
    }




    filterData = (value, type) => {

        let course = this.state.courseId,
            subject = this.state.subjectId,
            studentId = this.state.studentId,
            studentYear = this.state.studentYear,
            groupOrYear = this.state.groupOrYear;

        switch (type) {
            case 'course':
                course = value;
                this.setState({ courseId: course });
                break;
            case 'student':
                studentId = value;
                this.setState({ studentId: studentId });
                break;

            case 'subject':
                subject = value;
                this.setState({ subjectId: subject });
                break;

            case 'groupOrYear':
                groupOrYear = value;
                this.setState({ groupOrYear: groupOrYear });
                break;

            case 'filterStudentBtn':
                let userData = getItem('userData');
                let schoolId = userData ? userData.schoolId : '';

                let url = `groupId=${groupOrYear}&studentYear=${studentYear}&subjectId=${subject}&courseId=${course}&schoolId=${schoolId}&studentId=${studentId}`;
                this.setState({ loading: true });
                this.props.actions.fetchStudents(this.props.accessToken, url).then(() => {
                    this.setState({ loading: false });
                })
                this.setState({ isFiltered: true });
                break;

        }

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            students: nextProps.students,
            isDataLoaded: true
        };
    }


    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }


    getRowHeight = (params) => {
        return params.data.rowHeight;
    }

    render() {

        const columndef = [
            {
                headerName: "First Name",
                field: "firstName",
                minWidth: 250,
                sortable: true,
                unSortIcon: true,
                sortingOrder: ['asc'],
                cellRenderer: (params) => {
                    let id = params.data.studentId;
                    let name = params.data.firstName;

                    return `<a href=/student/${id}  class="uIdcolumn" >${name}</a>`;

                }
            },
            {
                headerName: "Last Name",
                field: "lastName",
                minWidth: 250,
                sortable: true,
                unSortIcon: true,
                sortingOrder: ['asc'],
                cellRenderer: (params) => {
                    let id = params.data.studentId;
                    let name = params.data.lastName;

                    return `<a href=/student/${id}  class="uIdcolumn" >${name}</a>`;

                }
            },
            {
                headerName: "Group",
                minWidth: 150,
                sortable: false,
                cellRenderer: (params) => {
                    let groups = params.data.groups;
                    let tpldata = '';
                    if (groups) {
                        groups.map((data, index) => {
                            let id = data.id,
                                name = data.label;
                            tpldata = tpldata + '<span><a href="/group/' + id + '?courseId=' + data.courseId + '" class="groupCol" >' + name + '</a> </span>';
                        });

                        return `<span style='padding-top: 5px; padding-bottom: 5px'>${tpldata}</span>`;

                    }
                }

            },

            {
                headerName: "Course",
                minWidth: 400,
                sortable: false,
                autoHeight: true,
                wrapText: true,
                cellRenderer: (params) => {

                    let courses = params.data.courses;
                    let tpldata = '';
                    if (courses) {
                        courses.map((data, index) => {
                            let id = data.id,
                                name = data.label;
                            tpldata = tpldata + '<span>' + name + '</span> <br /> ';
                        });

                        return tpldata;

                    }


                }
            }
        ];

        let dataUpdate = this.state.students;
        let data = this.state.students;
        dataUpdate.forEach((dataItem, index) => {
            let count = dataItem.groups.length > dataItem.courses.length ? dataItem.groups.length : dataItem.courses.length;

            dataItem.rowHeight = count > 2? count * 32: count * 40;

        });

        const tableConfig = {
            columndef: columndef,
            rowData: dataUpdate,
            // height: `${this.state.tableHeight}px`,
            domLayout: 'autoHeight',
            getRowHeight: this.getRowHeight,
            onGridReady: this.onGridReady,
            pagination: false
        };


        return (
            <div className="col">
                <div className="row">
                    <div className="col-md-5 course-title">Students</div>
                    <div className="col-md-7"></div>
                </div>

                <div className="row mr-top-10">
                    <div className="col-md-1 "></div>
                    <div className="col-md-2 ">
                        <label className="st-filter-lable-color">Student</label>
                        <EDWDropDown
                            items={[{ label: 'All students', id: '' }, ...this.props.allStudents]}
                            onChange={(value) => this.filterData(value, 'student')}
                            label="Select student"
                            value={this.state.studentId}
                        />
                    </div>
                    <div className="col-md-2 ">
                        <label className="st-filter-lable-color">Group/Year</label>
                        <EDWDropDown
                            items={[{ label: 'Select year/group', id: '' }, ...this.props.yearGroup]}
                            onChange={(value) => this.filterData(value, 'groupOrYear')}
                            label="Select group"
                            value={this.state.groupOrYear}
                        />
                    </div>
                    <div className="col-md-2 ">
                        <label className="st-filter-lable-color">Subject</label>
                        <EDWDropDown
                            items={[{ label: 'All subjects', id: '' }, ...this.props.subjects]}
                            onChange={(value) => this.filterData(value, 'subject')}
                            label="Select subject"
                            value={this.state.subjectId}
                        />
                    </div>
                    <div className="col-md-2 ">

                        <label className="st-filter-lable-color">Course</label>
                        <EDWDropDown
                            items={[{ label: 'All courses', id: '' }, ...this.props.course]}
                            onChange={(value) => this.filterData(value, 'course')}
                            label="Select course"
                            value={this.state.courseId}
                        />
                    </div>

                    <div className="col-md-3 " style={{ display: "flex", flexDirection: 'row', alignItems: 'flex-end', marginBottom: 3 }}>
                        <div><button onClick={(e) => this.filterData(e, 'filterStudentBtn')} className="Button Button-BG">Find students</button></div>
                    </div>
                </div>
                <div className="row">
                    <div className="card-background assessment-table">
                        {this.state.loading && <EdwLoaderWithContainer />}
                        {!this.state.loading && (this.state.isFiltered ? <EdwTable {...tableConfig} /> : <div className="min-height-200"></div>)}
                    </div>
                </div>

            </div>

        );
    }

}

const mapStateToProps = (state, props) => ({
    students: state.student.studentFilteredList,
    accessToken: state.auth.accessToken,
    subjects: state.common.subjects,
    course: state.common.course,
    yearGroup: state.common.groupListForDropDown,
    allStudents: state.common.allStudents,

});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...StudentActions, ...CommonActions }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Students);